import { j as e } from "./index.es3.js";
const r = ({ id: o, type: s, linktext: t }) => t && t.length > 0 ? /* @__PURE__ */ e.jsx("span", { id: s === "footnote" ? `reference_footnote_${o}` : `footnote_${o}`, className: "scroll-mt-[10rem]", children: /* @__PURE__ */ e.jsx("sup", { className: "text-[0.8rem] align-[4px]", children: /* @__PURE__ */ e.jsxs(
  "a",
  {
    href: s === "footnote" ? `#footnote_${o}` : `#reference_footnote_${o}`,
    className: "text-blue-600 cursor-pointer",
    children: [
      /* @__PURE__ */ e.jsx("span", { children: "[" }),
      t,
      /* @__PURE__ */ e.jsx("span", { children: "]" })
    ]
  }
) }) }) : null;
export {
  r as default
};
//# sourceMappingURL=index.es33.js.map
